import React, { useState } from 'react';
import cx from 'classnames';

import { LANDING_PAGE_EVENTS, LANDING_PAGE_SECTIONS_NAMES } from 'Utilities/analytics';

import { ComponentContent, CONTENT_SIZES } from 'Layout';

import TrustpilotReviewsCarousel from '../../../../../components/reviews/ReviewsCarousel/TrustpilotReviewsCarousel';

import styles from './Trustpilot.scss';

type Props = {
  wrapperClassName?: string;
}

export const Trustpilot = ({ wrapperClassName }: Props) => {
  const [failedReviewsCarousel, setFailedReviewsCarousel] = useState(false);

  const setFailedLoad = () => setFailedReviewsCarousel((prev) => !prev);

  const onLoad = () => LANDING_PAGE_EVENTS.SECTION_LOAD({
    name: LANDING_PAGE_SECTIONS_NAMES.TRUSTPILOT_WIDGET,
  });

  return (
    <ComponentContent
      className={cx({
        [styles.trustpilotEmpty]: failedReviewsCarousel,
        [styles.trustpilot]: !failedReviewsCarousel,
      }, wrapperClassName)}
      maxWidth={CONTENT_SIZES.none}
    >
      <TrustpilotReviewsCarousel
        largeTitle
        failedLoad={failedReviewsCarousel}
        {...{ onLoad, setFailedLoad }}
      />
    </ComponentContent>
  );
};
